var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notFound",on:{"click":function($event){return _vm.goback()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }